import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { HttpClient } from '@angular/common/http';

import { environment } from './http/environment';

import { Confirmation } from './confirmation/confirmation';
import { IGenericType } from '@library/common/generictype';

export interface CybersourcePayload {
   access_key: string;
   profile_id: string;
   transaction_uuid: string;
   signed_date_time: string;

   locale: string;
   transaction_type: string;

   amount: string;
   currency: string;

   reference_number: string;

   signed_field_names: string[];
   unsigned_field_names: string[];

   signature: string;
}

@Injectable({
  providedIn: 'root'
})
export class PaymentService {

   url = environment.origin;

   constructor(
      private http: HttpClient,
   ) {}

   getSignature( payload ): Observable<CybersourcePayload> {
      return this.http.post<IGenericType>( 'signature', payload, { params: { useLambda: true } } ).pipe(
         map( res => res.response ),
      );
   }

   getDetails( uuid: string ): Observable<Confirmation> {
      return this.http.get<IGenericType>( 'confirmation/' + uuid, { params: { useLambda: true } } ).pipe(
         map( res => new Confirmation( res.response )),
      );
   }

   sendEmail( payload ): Observable<boolean> {
      return this.http.post<IGenericType>( 'confirmation/email', payload, { params: { useLambda: true } } ).pipe(
         map( res => res.response ),
      );
   }
}
